module.exports = __webpack_public_path__ + "static/media/icon.1d252b22.png";